import React, { useState } from "react";
import { BasketItem } from "../../../models/BasketItem";
import EATextField from "../../shared/TextField/EATextField";
import HtmlTooltip from "@mui/material/Tooltip";
import { BiInfoCircle } from "react-icons/bi";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";

interface IProps {
  index: number;
  itemData: BasketItem;
  onUpdateBasketItem: (index: number, key: "qb_card" | "qb_pin", value: string) => void;
  isDuplicateQbCard?: boolean;
}

const QbBasketInputs: React.FC<IProps> = ({ index, itemData, onUpdateBasketItem, isDuplicateQbCard = false }) => {
  const { t } = useTranslation();
  const handleCardChange = (value: string) => {
    onUpdateBasketItem(index, "qb_card", value);
  };
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const handlePinChange = (value: string) => {
    onUpdateBasketItem(index, "qb_pin", value);
  };

  const serverError = itemData.qb_znizka_id <= 0 && Boolean(itemData.qb_message);
  const cardError = serverError || isDuplicateQbCard;
  const cardHelperText = isDuplicateQbCard
    ? t("qb_karta_duplikat")
    : itemData.qb_message
      ? itemData.qb_message
      : "";

  return (
    <div className="qb-basket-inputs-container">
      <EATextField
        name="card-code"
        label="Kod karty"
        value={itemData.qb_card}
        onChange={(e) => handleCardChange(e.target.value)}
        type="text"
        fullWidth
        error={cardError}
        success={itemData.qb_znizka_id > 0 && !isDuplicateQbCard}
        helperText={cardHelperText}
      />
      <EATextField
        name="pin"
        label="PIN"
        value={itemData.qb_pin}
        onChange={(e) => handlePinChange(e.target.value)}
        type="number"
        fullWidth
      />

{isDesktop ? (      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <article className="tooltip-description">
              Kod PIN znajdziesz w aplikacji Karta Łodzianina, wystarczy otworzyć aplikację i kliknąć w ikonkę klucza,
              pod zdjęciem profilowym.
            </article>
          </React.Fragment>
        }
      >
        <b>
          <BiInfoCircle className="tooltip-icon qb-basket-tooltip" />
        </b>
      </HtmlTooltip>
                  ): (
                  <b onClick={() => setOpen(!open)}>
                    <BiInfoCircle  className="tooltip-icon qb-basket-tooltip"  />
                  </b>
                )}

{open && (
        <div className="schedule-modal-info">
          <ModalComponent
            footer={false}
            open={open}
            closeModal={() => setOpen(false)}
            title={'Jak zdobyć PIN?'}
            onAccept={() => setOpen(false)}
            acceptText={t("przeczytalem")}
          >
           
              <p className="news-modal-body"> Kod PIN znajdziesz w aplikacji Karta Łodzianina, wystarczy otworzyć aplikację i kliknąć w ikonkę klucza,
              pod zdjęciem profilowym.</p>
          
          </ModalComponent>
        </div>
      )}
    </div>
  );
};

export default QbBasketInputs;
